// extracted by mini-css-extract-plugin
module.exports = {"feature":"bz_kc","feature_negative":"bz_kd","feature__icon":"bz_kf","feature__description":"bz_kg"};